export default {
    about_title: "myUoM Mobile App",
    about_version: "Version V1.2.0",
    about_find_us_on_socials: "Find us on Social Media",
    about_project_members_title: "Development Team Members"
}